(function () {
    'use strict';

    angular
        .module('app.editCustomReport')
        .factory('editCustomReportService', ['$q', '$http', '$rootScope',
            function ($q, $http, $rootScope) {
                var service = {};

                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    } 

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                        .error(function (result) {
                            deferred.reject(result);
                        });

                    return deferred.promise;
                }

                function editCustomReport(params, loader) {
                    var url_editCustomReport = $rootScope.apiUrl + 'measure/editCustomReport';
                    return handleRequest(url_editCustomReport, 'POST', params, loader);
                }

                service.editCustomReport = editCustomReport;

                return service;
            }
        ]);
})();
